// Climate Control Content
import ClimateControlHero from 'assets/images/psp/hero/climate-controlled-hero.webp';
import MediaAndElectronics from '/assets/images/icons/psp/media-electronics.svg';
import ValuableApparel from '/assets/images/icons/psp/valuable-apparel.svg';
import Furniture from '/assets/images/icons/psp/furniture.svg';
import Books from '/assets/images/icons/psp/books.svg';
import Wine from '/assets/images/icons/psp/wine.svg';
import MusicalInstruments from '/assets/images/icons/psp/musical-instrument.svg';
import Glass from '/assets/images/icons/psp/glass.svg';
import Antiques from '/assets/images/icons/psp/antiques.svg';
import Medical from '/assets/images/icons/psp/medical.svg';
import Makeup from '/assets/images/icons/psp/makeup.svg';
import HouseholdAppliances from '/assets/images/icons/psp/appliances.svg';
import SportingEquipment from '/assets/images/icons/psp/sports.svg';
import ClimateControl1 from 'assets/images/psp/FeaturedImages/climate1.webp';
import ClimateControl2 from 'assets/images/psp/FeaturedImages/climate2.webp';
import ClimateControl3 from 'assets/images/psp/FeaturedImages/self2.webp';
import ClimateControl4 from 'assets/images/psp/FeaturedImages/self1.webp';
const reviews = [
	{
		reviewTitle:
			'I was able to reserve a large climate-controlled storage unit',
		reviewRating: 5,
		reviewText:
			'I was able to reserve a large climate-controlled storage unit 10x30 in just a few minutes. Easy.',
		reviewerInitials: 'CR',
		link: 'https://www.trustpilot.com/reviews/6829ffe51ec3d0d5b4391f7a',
		reviewerName: 'Cathy Ratley',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Fast and Easy Search',
		reviewRating: 5,
		reviewText:
			'This was a fast and easy search to find a storage unit near me with climate control. Very easy to reserve the unit for use as well.',
		reviewerInitials: 'JT',
		link: 'https://www.trustpilot.com/reviews/656df9349864d68ff85a9996',
		reviewerName: 'Judith Talarico',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'The site was very easy to use',
		reviewRating: 5,
		reviewText:
			'I found a great climate-controlled storage unit (10x17) for $145 a month. Reservations are good for a week or two, but it’s always best to confirm with the location dates/times.',
		reviewerInitials: 'ES',
		link: 'https://www.trustpilot.com/reviews/64ada176c423446286861e96',
		reviewerName: 'Elisha Stanton',
		reviewDate: 'January 3rd, 2023',
	},
	{
		reviewTitle: 'Very user-friendly',
		reviewRating: 5,
		reviewText:
			"Very user-friendly, efficient and up-to-date information. Really appreciated this since I'm not from this area and had no idea where to look for climate-controlled storage here.",
		reviewerInitials: 'B',
		link: 'https://www.trustpilot.com/users/5ebd4d0a37a9ffc4e86cfb08',
		reviewerName: 'Branson',
		reviewDate: 'January 3rd, 2023',
	},
];

const faqs = [
	{
		question: 'Do I Need Climate-Controlled Storage?',
		answer:
			'You can determine whether you will need **climate-controlled storage** based on your **items**, your **location**, and the **intended storage duration**.\n\n' +
			'If you are storing any of the **climate-sensitive items** listed [here](#storage-unit-size-chart), a climate-controlled unit is recommended to help protect them and maintain their condition.',
	},
	{
		question: 'What Types of Items Need Climate-Controlled Storage?',
		answer:
			'Items sensitive to **temperature** or **humidity** often require climate-controlled storage.\n\n' +
			'These can include small items like **books**, **photographs**, and **electronics**, as well as larger items like **furniture** and **household appliances**.\n\n' +
			'For a more detailed list, refer to the items listed [here](#storage-unit-size-chart).',
	},
	{
		question: 'What Are the Benefits of Climate-Controlled Storage?',
		answer:
			'Climate-controlled storage helps protect your belongings from **temperature fluctuations**, guarding against **humidity-related damage**, and often providing **advanced security measures**.\n\n' +
			'Knowing your items are being kept at a proper temperature can provide significant **peace of mind**.',
	},
	{
		question: 'What Are the Different Climate-Controlled Storage Types?',
		answer:
			'There are three main types of climate-controlled storage units:\n\n' +
			'- **Climate-controlled storage unit:** Your storage unit is kept within a safe temperature range, usually between **55–80°F**.\n' +
			'- **Air-conditioned or heated storage unit:** Cold or hot air is blown into the facility and/or unit.\n' +
			'- **Humidity-controlled storage unit:** Humidity control actively dehumidifies the air and keeps humidity levels around **55%**.',
	},
	{
		question: 'What Are Common Climate-Controlled Storage Unit Sizes?',
		answer:
			'Our [storage unit size guide](https://www.sparefoot.com/storage-unit-size-guide.html) breaks down the standard unit sizes available at most storage facilities.\n\n' +
			'While climate-controlled storage units are the same sizes as traditional storage, they’re typically **indoor units** as opposed to outdoor units that have an **external, drive-up door**.\n\n' +
			'Indoor units are located **inside the building** and are only accessible through the storage facility’s **hallways**.',
	},
];

export const ClimateControlContent = {
	type: 'Climate Controlled',
	sections: [
		{
			title: 'Climate Control Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'climate-control-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Climate Controlled Storage For You',
							description:
								'Worried about heat, cold, or humidity ruining your stuff? Climate-controlled storage, or “temperature-controlled storage,” maintains an indoor temperature range' +
								' between 50°F to 80°F with stable humidity to protect items such as furniture, electronics, and photographs from warping, molding, or falling apart. SpareFoot makes it easy to find and reserve the right climate-controlled storage unit for y' +
								'our needs.',
							image: ClimateControlHero,
							CTAText: 'Find Deals on Climate Control',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Climate Controlled Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Climate video section',
			background: 'dark',
			modules: [
				{
					type: 'videoSection',
					props: {
						slug: 'Benefits of Climate-Controlled Storage',
						src: 'https://www.youtube.com/embed/nrycCcs9IJ0',
						content: {
							title: 'Benefits of Climate-Controlled Storage',
							description:
								'When it comes to safeguarding your possessions, climate-controlled storage offer' +
								's numerous benefits, such as protecting your belongings from temperature fluctua' +
								'tions, guarding against humidity-related damage, and providing advanced security' +
								' measures.',
						},
					},
				},
			],
		},
		{
			title: 'Storage Unit Size Chart',
			modules: [
				{
					type: 'sizeChart',
					props: {
						slug: 'climate-size-chart',
						title: 'What Can Be Stored in a Climate Controlled Storage Unit?',
						headers: [
							{
								label: 'Items',
								key: 'items',
							},
							{
								label: 'Why you need climate control',
								key: 'Why you need climate control',
							},
						],
						rows: [
							{
								items: {
									type: 'icon',
									icon: MediaAndElectronics,
									description: '#### Media and electronics',
								},
								'Why you need climate control':
									'Humidity can corrode internal components, damage screens, and lead to malfunction or shortened lifespan. Climate control keeps moisture and temperature stable, so your electronics stay functional.',
							},
							{
								items: {
									type: 'icon',
									icon: ValuableApparel,
									description: '#### Valuable apparel',
								},
								'Why you need climate control': {
									type: 'markdown',
									markdown:
										'If you’re storing [wedding dresses](https://sparefoot.com/blog/how-to-store-a-wedding-dress), vintage clothing, [designer items](https://sparefoot.com/blog/how-to-store-purses), [hats](https://sparefoot.com/blog/how-to-store-hats), garments with lace or leather, etc., climate control can help preserve fabric integrity and value.',
								},
							},
							{
								items: {
									type: 'icon',
									icon: Furniture,
									description:
										'#### [Wood](https://sparefoot.com/blog/how-to-store-wood-furniture), metal, wicker, leather or upholstered furniture',
								},
								'Why you need climate control':
									'Organic materials on your furniture are vulnerable to mold and mildew. Climate control will protect against both long-term damage and unpleasant odors.',
							},
							{
								items: {
									type: 'icon',
									icon: Books,
									description:
										'#### [Books](https://sparefoot.com/blog/the-sparefoot-guide-to-storing-books), documents, artwork, or photographs',
								},
								'Why you need climate control': {
									type: 'markdown',
									markdown:
										'Paper and ink are highly susceptible to moisture. Use climate control to protect important documents and [sentimental items](https://sparefoot.com/blog/store-kids-sentimental-items-long-term) from growing mold, yellowing, and warping.',
								},
							},
							{
								items: {
									type: 'icon',
									icon: Wine,
									description: '#### Wine',
								},
								'Why you need climate control':
									'Wine requires stable temperatures and humidity to avoid premature aging and oxidation. Many storage facilities offer storage lockers specifically catered to optimal wine storage',
							},
							{
								items: {
									type: 'icon',
									icon: MusicalInstruments,
									description: '#### Musical instruments',
								},
								'Why you need climate control':
									'Instruments can crack, warp, or lose tuning due to changes in temperature or humidity. You can keep them in playable condition by using climate control to preserve their shape and sound quality.',
							},
							{
								items: {
									type: 'icon',
									icon: Glass,
									description:
										'#### Glass, metal and plastics',
								},
								'Why you need climate control':
									'Climate control will protect your items from warping, melting, and discoloring over time.',
							},
							{
								items: {
									type: 'icon',
									icon: Antiques,
									description:
										'#### Antiques and collectibles',
								},
								'Why you need climate control': {
									type: 'markdown',
									markdown:
										"Humidity levels are important for the preservation of your antiques ([grandfather's clocks](https://sparefoot.com/blog/how-to-store-a-grandfather-clock-the-right-way), artwork, etc.) and collectibles (stamps, coins, [comic books](https://sparefoot.com/blog/how-to-store-comic-books), etc.).",
								},
							},
							{
								items: {
									type: 'icon',
									icon: Medical,
									description:
										'#### Medical supplies and medications',
								},
								'Why you need climate control':
									'Extreme temperatures can cause adhesives to lose their stickiness. Climate control can prevent damage to materials like latex and plastic and keep your supplies safe.',
							},
							{
								items: {
									type: 'icon',
									icon: Makeup,
									description: '#### Makeup and toiletries',
								},
								'Why you need climate control':
									'Climate control can prevent makeup and toiletries from drying out or cracking, getting too damp (making it a breeding ground for bacteria), melting, and more.',
							},
							{
								items: {
									type: 'icon',
									icon: HouseholdAppliances,
									description: '#### Household appliances',
								},
								'Why you need climate control': {
									type: 'markdown',
									markdown:
										'The amount of metal present in [household appliances](https://sparefoot.com/blog/how-to-store-kitchen-appliances) makes rust an issue in places with high humidity. Choose climate control to protect valuable items such as [fridges](https://sparefoot.com/blog/storing-a-fridge) against extreme temperatures.',
								},
							},
							{
								items: {
									type: 'icon',
									icon: SportingEquipment,
									description: '#### Sporting equipment',
								},
								'Why you need climate control':
									'Sporting gear is susceptible to cracking and breaking in extreme temperatures. With climate control, you can keep them in tip-top shape during off-season storage.',
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Real Reviews of Climate Controlled Storage Units on SpareFoot',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Climate-Controlled Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'September 22, 2025',
								image: ClimateControl1,
								link: 'https://sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit',
								content:
									'What Are Climate-Controlled Storage Units?',
							},
							{
								title: 'Self Storage',
								date: 'October 17, 2025',
								image: ClimateControl2,
								link: 'https://www.sparefoot.com/blog/how-are-storage-units-measured',
								content: 'How Are Storage Units Measured?',
							},
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: ClimateControl3,
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								content:
									'How to Pick the Right Size Self-Storage Unit',
							},
							{
								title: 'Self Storage',
								date: 'October 22, 2025',
								image: ClimateControl4,
								link: 'https://www.sparefoot.com/blog/what-is-self-storage-2',
								content: 'What Is Self-Storage?',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'24Hour',
							'DriveUp',
							'Electricity',
							'Wine',
							'Car',
							'RV',
							'Motorcycle',
							'Business',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
